var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarElite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.012 10.834a.621.621 0 00-.62.62v1.452a.621.621 0 00.62.62h.786a.621.621 0 00.62-.62v-1.452a.621.621 0 00-.62-.62h-.786zM16.558 13.575h-.787a.67.67 0 01-.669-.67v-1.45a.67.67 0 01.669-.67h.787a.67.67 0 01.668.67v1.45a.67.67 0 01-.668.67z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.036 12.412H2.486c-.617 0-1.119-.363-1.119-.81V8.996l.673-.708h14.572l.542.71v2.604c0 .447-.502.81-1.118.81z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.55 9.592H2.116l-.147-2.25.094-.23.542-1.334h13.356l.734 1.516-.147 2.298z",
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#car-elite_svg__filter0_f_5476_25753)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.375,
    cy: 8.645,
    rx: 2,
    ry: 4.054,
    transform: "rotate(-45 9.375 8.645)",
    fill: "#F5F7FA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.672 7.298l-.108 1.69h-3.175V7.733l3.192-.62.09.185zM5.23 7.733v1.255H2.101l-.107-1.641.091-.225 3.143.61z",
    fill: "#6F6F6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.882 6.164H2.686l1.408-4.691A.942.942 0 014.99.799L13.73.715a.946.946 0 01.925.71l1.227 4.739z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.866 5.72L3.7 5.588a.09.09 0 01-.085-.118l1.07-3.34a.09.09 0 01.087-.062h8.98a.09.09 0 01.086.062l1.115 3.473a.091.091 0 01-.013.08.09.09 0 01-.074.037z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.695 6.067H.715v-.435a.531.531 0 01.53-.53h1.45v.965zM17.854 6.067h-1.98v-.965h1.45a.531.531 0 01.53.53v.435z",
    fill: "#EBEBEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "car-elite_svg__filter0_f_5476_25753",
    x: 2.988,
    y: 2.258,
    width: 12.774,
    height: 12.774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.595,
    result: "effect1_foregroundBlur_5476_25753"
  })))));
}
export default __webpack_public_path__ + "static/media/car-elite.2b79a4d5.svg";
export { SvgCarElite as ReactComponent };